<template>
    <div>
        <b-modal
            id="terms-service-popup"
            title="Terms of Service"
            size="lg"
            hide-footer
            no-close-on-backdrop
        >
            <div id="style-3" class="scrollable">
                <div>
                    <p>IDENFO DIRECT TERMS &amp; CONDITIONS</p>
                    <p>CONTENTS</p>
                    <p>
                        ____________________________________________________________
                    </p>
                    <p>CLAUSE</p>
                    <p>
                        <a>
                            <em>1.</em>
                            <em>
                                About
                                us.....................................................................................................................
                            </em>
                            <em>1</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>2.</em>
                            <em>
                                Our contract with
                                you.................................................................................................
                            </em>
                            <em>1</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>3.</em>
                            <em>
                                Placing an order and its
                                acceptance.........................................................................
                            </em>
                            <em>2</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>4.</em>
                            <em>
                                Cancelling your order and obtaining a
                                refund...........................................................
                            </em>
                            <em>2</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>5.</em>
                            <em>
                                Our
                                services...............................................................................................................
                            </em>
                            <em>3</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>6.</em>
                            <em>
                                Your
                                obligations.........................................................................................................
                            </em>
                            <em>4</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>7.</em>
                            <em>
                                Charges.....................................................................................................................
                            </em>
                            <em>5</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>8.</em>
                            <em>
                                How to
                                pay.................................................................................................................
                            </em>
                            <em>6</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>9.</em>
                            <em>
                                Complaints.............................................................................................................
                            </em>
                            <em>7</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>10.</em>
                            <em>
                                Intellectual property
                                rights......................................................................................
                            </em>
                            <em>7</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>11.</em>
                            <em>
                                How we may use your personal
                                information.........................................................
                            </em>
                            <em>7</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>12.</em>
                            <em>
                                Limitation of liability: YOUR ATTENTION IS
                                PARTICULARLY DRAWN TO THIS
                                CLAUSE............................................................................................................................
                            </em>
                            <em>7</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>13.</em>
                            <em>
                                Confidentiality.........................................................................................................
                            </em>
                            <em>9</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>14.</em>
                            <em>
                                Termination, consequences of termination and
                                survival.......................................
                            </em>
                            <em>9</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>15.</em>
                            <em>
                                Events outside our
                                control...................................................................................
                            </em>
                            <em>10</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>16.</em>
                            <em>
                                Non-solicitation.....................................................................................................
                            </em>
                            <em>11</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>17.</em>
                            <em>
                                Communications between
                                us...............................................................................
                            </em>
                            <em>11</em>
                        </a>
                    </p>
                    <p>
                        <a>
                            <em>18.</em>
                            <em>
                                General.................................................................................................................
                            </em>
                            <em>11</em>
                        </a>
                    </p>
                </div>
                <strong>
                    <br clear="all" />
                </strong>
                <p>AGREED TERMS</p>
                <p>
                    <a name="a585916">
                        Your attention is particularly drawn to the provisions
                        of
                    </a>
                    clause 12 (Limitation of liability).
                </p>
                <p>
                    1. <a name="_Toc256000000"></a
                    ><a name="a905165">About us</a>
                </p>
                <p>
                    <a name="a555308">
                        1.1 <strong>Company details.</strong> IDENFO LIMITED
                        (company number 12001945) (<strong>we</strong> and
                        <strong>us</strong>) is a company registered in England
                        and Wales and our registered office is at Bankside 300
                        Peachman Way, Broadland Business Park, Norwich, Norfolk,
                        United Kingdom, NR7 0LB. Our UK VAT number is 330 2250
                        61. We operate the websites
                    </a>
                    <a href="https://www.idenfo.com/"
                        ><em>https://www.idenfo.com/</em></a
                    >
                    and
                    <a href="https://www.idenfodirect.com/">
                        <em>https://www.idenfodirect.com/</em>
                    </a>
                    (<strong>Site</strong>).
                </p>
                <p>
                    <a name="a891579">
                        <strong>1.2 </strong>
                        <strong>Contacting us.</strong>
                        To contact us, please email us at support@idenfo.com.
                        How to give us formal notice of any matter under the
                        Contract is set out in
                    </a>
                    clause 17.2.<strong></strong>
                </p>
                <p>
                    2. <a name="_Toc256000001"></a
                    ><a name="a606823">Our contract with you</a>
                </p>
                <p>
                    <a name="a538773">
                        2.1 <strong>Our contract.</strong> These terms and
                        conditions ( <strong>Terms</strong>) apply to the order
                        by you and supply of Services by us to you (
                    </a>
                    Contract). They apply to the exclusion of any other terms
                    that you seek to impose or incorporate, or which are implied
                    by law, trade custom, practice or course of dealing.
                </p>
                <p>
                    <a name="a175999">
                        2.2 <strong>Entire agreement.</strong> The Contract is
                        the entire agreement between you and us in relation to
                        its subject matter. You acknowledge that you have not
                        relied on any statement, promise or representation or
                        assurance or warranty that is not set out in the
                        Contract.
                    </a>
                </p>
                <p>
                    <a name="a788019">
                        <strong>2.3 </strong>
                        <strong>Language.</strong>
                        These Terms and the Contract are made only in the
                        English language.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a625448">
                        2.4 <strong>Your copy.</strong> You should print off a
                        copy of these Terms or save them to your computer for
                        future reference.
                    </a>
                </p>
                <p>
                    3. Registering with us, <a name="_Toc256000002"></a>
                    <a name="a683230">placing an order and its acceptance</a>
                </p>
                <p>
                    <a name="a641125">
                        3.1 Registering with us. Please follow the onscreen
                        prompts to register with us. You may only register using
                        the method set out on the Site.
                    </a>
                </p>
                <p>
                    3.2 <strong>Placing your order.</strong> Please follow the
                    onscreen prompts to place your order. You may only submit an
                    order using the method set out on the Site. Each order is an
                    offer by you to buy the services specified in the order
                    (<strong>Services</strong>) subject to these Terms.
                </p>
                <p>
                    <a name="a791423">
                        3.3 <strong>Correcting input errors.</strong> Please
                        check the order carefully before confirming it. You are
                        responsible for ensuring that your order and any
                        specification submitted by you is complete and accurate.
                    </a>
                </p>
                <p>
                    <a name="a710463">
                        <strong
                            >Acknowledging receipt and accepting your order.
                        </strong>
                        After you place your order, you will either receive an
                        email from us acknowledging that we have received it and
                        accepted it, or you will be able to view your order and
                        its Acceptance on our Site (
                        <strong>Order Confirmation</strong>).
                    </a>
                    <a name="a914363">
                        On the date of Acceptance, (<strong
                            >Commencement Date</strong
                        >) the Contract between you and us will come into
                        existence. The Contract will relate only to those
                        Services confirmed in the Order Confirmation.
                    </a>
                </p>
                <p>
                    <a name="a696609">
                        <strong>3.4 </strong>
                        <strong>If we cannot accept your order.</strong>
                        If we are unable to supply you with the Services for any
                        reason, we will inform you of this by email and we will
                        not process your order. If you have already paid for the
                        Services, we will refund you the full amount.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    4. <a name="_Toc256000003"></a
                    ><a name="a244843">Cancelling your order</a>
                    and obtaining a refund
                </p>
                <p>
                    4.1 Our services are provided on a subscription basis. You may cancel the Contract at any time in
                    any month. On receipt of satisfactory notice given in accordance with these terms and conditions,
                    you will not receive any refund for the remainder of the month in which you gave notice, but your
                    contract with us will then terminate at the end of that month with no further monies being taken for
                    the following month.
                </p>
                <p>
                    <a name="a111615">
                        4.2 To cancel the Contract, you must enter our Site and
                        follow the onscreen prompts. We will email you to
                        confirm we have received your cancellation or you can
                        view it on the Site.
                    </a>
                </p>
                <p>
                    <a name="a855733">
                        4.3 If you cancel the Contract, we will stop taking
                        payments from you from the following month
                    </a>
                    ’s payment date.
                </p>
                <p>
                    5. <a name="_Toc256000004"></a
                    ><a name="a771894">Our services</a>
                </p>
                <p>
                    <a name="a900780">
                        <strong>5.1 </strong>
                        <strong
                            >Service availability, descriptions and
                            illustrations.
                        </strong>
                        The Services will be generally available except for
                        00:00 - 06:00. The downtime periods will be timed to
                        minimise customer disruption. Any descriptions or
                        illustrations on our Site are published for the sole
                        purpose of giving an approximate idea of the services
                        described in them. They will not form part of the
                        Contract or have any contractual force.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a801660">
                        5.2 <strong>Compliance with specification</strong>.
                        Subject to our right to amend the specification (see
                    </a>
                    clause 5.3) we will supply the Services to you in accordance with the specification for the Services
                    appearing on our Site at the date of your order in all material respects. The Services provided
                    cover document verification (including facial comparison and liveness capability), money laundering
                    risk assessment and name screening. Name screening is based around a system that utilises a
                    comparable algorithm to compare similarity in names with additional scoring adjustments made on
                    other data (such as date of birth or nationality) provided. It should be noted that customer records
                    which vary considerably from screening lists beyond the range of the system's parameters will not
                    generate a hit. Name screening is also augmented by real time adverse media checks which are
                    performed in the English language. It should be noted that to the extent that our services provide a
                    tool for efficient compliance processing, such a tool in no way assumes on Idenfo a responsibility
                    for your compliance obligations.
                </p>
                <p>
                    <a name="a486908">
                        5.3 <strong>Changes to specification.</strong> We
                        reserve the right to amend the specification of the
                        Services if required by any applicable statutory or
                        regulatory requirement or if the amendment will not
                        materially affect the nature or quality of the Services.
                    </a>
                </p>
                <p>
                    <a name="a391289">
                        5.4 <strong>Reasonable care and skill.</strong> We
                        warrant to you that the Services will be provided using
                        reasonable care and skill.
                    </a>
                </p>
                <p>
                    <a name="a357672">
                        <strong>5.5 </strong>
                        <strong>Time for performance.</strong>
                        We will use all reasonable endeavours to meet any
                        performance dates specified in the Order Confirmation,
                        but any such dates are estimates only and failure to
                        perform the Services by such dates will not give you the
                        right to terminate the Contract.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    6. <a name="_Toc256000005"></a
                    ><a name="a182315">Your obligations</a>
                </p>
                <p>
                    <a name="a162617">
                        <strong>6.1 </strong>
                        It is your responsibility to ensure that:
                    </a>
                    <strong></strong>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a261881">
                            (a) the terms of your order are complete and
                            accurate;
                        </a>
                    </p>
                    <p>
                        <a name="a469612">
                            (b) you cooperate with us in all matters relating to
                            the Services;
                        </a>
                    </p>
                    <p>
                        <a name="a343213">
                            (c) you provide us with such information and
                            materials we may reasonably require in order to
                            supply the Services, and ensure that such
                            information is complete and accurate in all material
                            respects;
                        </a>
                    </p>
                    <p>
                        <a name="a702010">
                            (d) you obtain and maintain all necessary licences,
                            permissions and consents which may be required for
                            the Services before the date on which the Services
                            are to start;
                        </a>
                    </p>
                    <p>
                        <a name="a114865">
                            (e) you comply with all applicable laws, including
                            but not limited to privacy and data protection laws;
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a262374">
                        6.2 If our ability to perform the Services is prevented
                        or delayed by any failure by you to fulfil any
                        obligation listed in
                    </a>
                    clause 6.1 (Your Default):
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a667280">
                            (a) we will be entitled to suspend performance of
                            the Services until you remedy Your Default, and to
                            rely on Your Default to relieve us from the
                            performance of the Services, in each case to the
                            extent Your Default prevents or delays performance
                            of the Services. In certain circumstances Your
                            Default may entitle us to terminate the Contract
                            under
                        </a>
                        clause 15 (Termination);
                    </p>
                    <p>
                        <a name="a934313">
                            (b) we will not be responsible for any costs or
                            losses you sustain or incur arising directly or
                            indirectly from our failure or delay to perform the
                            Services; and
                        </a>
                    </p>
                    <p>
                        <a name="a447672">
                            (c) it will be your responsibility to reimburse us
                            on written demand for any costs or losses we sustain
                            or incur arising directly or indirectly from Your
                            Default.
                        </a>
                    </p>
                </div>
                <p>
                    7. <a name="a587362"></a><a name="_Toc256000007">Charges</a>
                </p>
                <p>
                    <a name="a240539">
                        7.1 In consideration of us providing the Services you
                        must pay our charges (<strong>Charges</strong>) in
                        accordance with this
                    </a>
                    clause 7.
                </p>
                <p>
                    <a name="a204446">
                        7.2 The Charges are based on the subscriptions quoted on
                        our Site at the time you submit your order.
                    </a>
                </p>
                <p>
                    <a name="a902005">
                        7.3 If you wish to change the scope of the Services
                        after we accept your order, and we agree to such change,
                        we will modify the Charges accordingly.
                    </a>
                </p>
                <p>
                    <a name="a940085">
                        7.4 We take all reasonable care to ensure that the
                        prices stated for the Services are correct at the time
                        when the relevant information was entered into the
                        system.
                    </a>
                </p>
                <p>
                    <a name="a503189">
                        7.5 Our Charges may change from time to time, but
                        changes will not affect any order you have already
                        placed
                    </a>
                    .
                </p>
                <p>
                    <a name="a744261">
                        7.6 Our Charges are exclusive of VAT. Where VAT is
                        payable in respect of some or all of the Services you
                        must pay us such additional amounts in respect of VAT,
                        at the applicable rate, at the same time as you pay the
                        Charges.
                    </a>
                </p>
                <p>
                    8. <a name="_Toc256000008"></a
                    ><a name="a448142">How to pay</a>
                </p>
                <p>
                    <a name="a343388">
                        8.1 Payment for the Services is in advance. We will take
                        your payment upon acceptance of your order via
                    </a>
                    Stripe, whose terms and conditions you agree to comply with
                    and are
                    <em><a href="https://stripe.com/gb/legal">here</a>.</em>
                </p>
                <p>
                    <a name="a319178">
                        8.2 We will send you an electronic invoice. For any
                        failed or cancelled payments, a £20 administration fee
                        will be levied.
                    </a>
                </p>
                <p>
                    9. <a name="_Toc256000009"></a
                    ><a name="a302157">Complaints</a>
                </p>
                <p>
                    <a name="a499366">
                        If a problem arises or you are dissatisfied with the
                        Services,
                    </a>
                    at first instance please contact us at
                    support@idenfo.com<strong></strong>
                </p>
                <p>
                    10. <a name="_Toc256000010"></a>
                    <a name="a258866">Intellectual property rights</a>
                </p>
                <p>
                    <a name="a735660">
                        10.1 All intellectual property rights in or arising out
                        of or in connection with the Services (other than
                        intellectual property rights in any materials provided
                        by you),
                    </a>
                    including but not limited to trademarks, trade names, logos,
                    copyright and database will be owned by us. You may access
                    and view the information and may retrieve and display
                    information from the Site on a device and/or print
                    individual pages on paper and/or make a reasonable number of
                    photocopies and/or store such information in electronic form
                    on your computer’s local hard-disk for your personal,
                    non-commercial use only. No part of the information and
                    material may be copied, distributed, reproduced, published
                    or used without our prior written consent.
                </p>
                <p>
                    <a name="a678853">
                        10.2 You agree to grant us a fully paid-up,
                        non-exclusive, royalty-free, non-transferable licence to
                        copy and modify any materials or data provided by you to
                        us for the term of the Contract for the purpose of
                        providing the Services to you.
                    </a>
                </p>
                <p>
                    11. <a name="_Toc256000011"></a>
                    <a name="a115327"
                        >How we may use your personal information</a
                    >
                </p>
                <p>
                    <a name="a507339">
                        11.1 We will use any personal information you provide to
                        us to:
                    </a>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a859934"
                            >(a) provide and improve the Services;
                        </a>
                    </p>
                    <p>
                        <a name="a146407"
                            >(b) process your payment for the Services; and</a
                        >
                    </p>
                    <p>
                        <a name="a876982">
                            (c) inform you about similar services that we
                            provide, but you may stop receiving these at any
                            time by contacting us.
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a237507">
                        11.2 We will process your personal information in
                        accordance with our Privacy Policy, the terms of which
                        are incorporated into this Contract.
                    </a>
                </p>
                <p>
                    12. <a name="_Toc256000012"></a>
                    <a name="a374023">
                        Limitation of liability: YOUR ATTENTION IS PARTICULARLY
                        DRAWN TO THIS CLAUSE.
                    </a>
                </p>
                <p>
                    <a name="a604464">
                        12.1 Nothing in the Contract limits any liability which
                        cannot legally be limited, including liability for:
                    </a>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a380044">
                            (a) death or personal injury caused by negligence
                            and;
                        </a>
                    </p>
                    <p>
                        <a name="a173326"
                            >(b) fraud or fraudulent misrepresentation; and</a
                        >
                    </p>
                    <p>
                        <a name="a790256">
                            (c) breach of the terms implied by section 2 of the
                            Supply of Goods and Services Act 1982 (title and
                            quiet possession).
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a418831">12.2 Subject to </a>
                    clause 12.1, we will not be liable to you, whether in
                    contract, tort (including negligence), for breach of
                    statutory duty, or otherwise, arising under or in connection
                    with the Contract for:
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a136412">(a) loss of profits;</a>
                    </p>
                    <p>
                        <a name="a117226">(b) loss of sales or business;</a>
                    </p>
                    <p>
                        <a name="a440891"
                            >(c) loss of agreements or contracts;</a
                        >
                    </p>
                    <p>
                        <a name="a93065">(d) loss of anticipated savings;</a>
                    </p>
                    <p>
                        <a name="a488274">
                            (e) loss of use or corruption of software, data or
                            information;
                        </a>
                    </p>
                    <p>
                        <a name="a129281">(f) loss of or damage to goodwill</a>
                    </p>
                    <p>
                        (g) any loss owing or arising as a result of any error,
                        incorrect information or out of date information in any
                        third party database or resource used by us as part of
                        providing the Services; and
                    </p>
                    <p>
                        <a name="a125109"
                            >(h) any indirect or consequential loss.</a
                        >
                    </p>
                </div>
                <p>
                    <a name="a747040">12.3 Subject to </a>
                    clause 12.1, our total liability to you arising under or in
                    connection with the Contract, whether in contract, tort
                    (including negligence), breach of statutory duty, or
                    otherwise, will be limited to the payments made and received
                    by us under the Contract over the preceding 12 months less
                    any processing fees paid under the Contract.
                </p>
                <p>
                    <a name="a700964">
                        12.4 We have given commitments as to compliance of the
                        Services with the relevant specification in
                    </a>
                    clause 5.2. In view of these commitments, the terms implied
                    by sections 3, 4 and 5 of the Supply of Goods and Services
                    Act 1982 are, to the fullest extent permitted by law,
                    excluded from the Contract<a name="a831810"></a>
                </p>
                <p>
                    12.5 Unless you notify us that you intend to make a claim in
                    respect of an event within the notice period, we shall have
                    no liability for that event. The notice period for an event
                    shall start on the day on which you became, or ought
                    reasonably to have become, aware of the event having
                    occurred and shall expire three (3) months from that date.
                    The notice must be in writing and must identify the event
                    and the grounds for the claim in reasonable detail.
                </p>
                <p>
                    12.6 The information and contents available on our Site are
                    for general information and use and is provided on an “as
                    is” basis. Whilst we take all reasonable care to check the
                    accuracy and completeness of the information and contents of
                    our Site, to the fullest extent permitted by law, we make no
                    representation and give no warranties as to the
                    completeness, accuracy, availability or fitness for any
                    particular purpose of the information and contents.
                </p>
                <p>
                    <a name="a104788">12.7 This </a>
                    clause 12 will survive termination of the Contract.
                </p>
                <p>
                    13. <a name="a425275"></a
                    ><a name="_Toc256000013">Confidentiality</a>
                </p>
                <p>
                    <a name="a153104">
                        13.1 We each undertake that we will not at any time
                        during the Contract, and for a period of five years
                        after termination of the Contract, disclose to any
                        person any confidential information concerning one
                        another's business, affairs, customers, clients or
                        suppliers, except as permitted by
                    </a>
                    clause 13.2.
                </p>
                <p>
                    <a name="a517446">
                        13.2 We each may disclose the other's confidential
                        information:
                    </a>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a788128">
                            (a) to such of our respective employees, officers,
                            representatives, subcontractors or advisers who need
                            to know such information for the purposes of
                            exercising our respective rights or carrying out our
                            respective obligations under the Contract. We will
                            each ensure that such employees, officers,
                            representatives, subcontractors or advisers comply
                            with this
                        </a>
                        clause 13; and
                    </p>
                    <p>
                        <a name="a489125">
                            (b) as may be required by law, a court of competent
                            jurisdiction or any governmental or regulatory
                            authority.
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a525096">
                        13.3 Each of us may only use the other's confidential
                        information for the purpose of fulfilling our respective
                        obligations under the Contract.
                    </a>
                </p>
                <p>
                    14. <a name="_Toc256000014"></a
                    ><a name="a243376">Termination</a>, consequences of
                    termination and survival
                </p>
                <p>
                    <a name="a632299">
                        14.1 <strong>Term</strong>i<strong>nation. </strong
                        >Without limiting any of our other rights, we may
                        suspend the performance of the Services, or terminate
                        the Contract with immediate effect by giving written
                        notice to you if:
                    </a>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a388666">
                            (a) In the case where you have signed up for the
                            Services for a trial period or to use any free trial
                            screenings without any subscription being payable,
                            you then fail to access any of the Services for any
                            period of 60 days or more;
                        </a>
                    </p>
                    <p>
                        (b) you commit a material breach of any term of the
                        Contract and (if such a breach is remediable) fail to
                        remedy that breach within 14 days of you being notified
                        in writing to do so;
                    </p>
                    <p>
                        <a name="a144574">
                            (c) you fail to pay any amount due under the
                            Contract on the due date for payment;
                        </a>
                    </p>
                    <p>
                        <a name="a452269">
                            (d) you take any step or action in connection with
                            you entering administration, provisional liquidation
                            or any composition or arrangement with your
                            creditors (other than in relation to a solvent
                            restructuring), applying to court for or obtaining a
                            moratorium under Part A1 of the Insolvency Act 1986,
                            being wound up (whether voluntarily or by order of
                            the court, unless for the purpose of a solvent
                            restructuring), having a receiver appointed to any
                            of your assets or ceasing to carry on business or,
                            if the step or action is taken in another
                            jurisdiction, in connection with any analogous
                            procedure in the relevant jurisdiction;
                        </a>
                    </p>
                    <p>
                        <a name="a749558">
                            (e) you suspend, threaten to suspend, cease or
                            threaten to cease to carry on all or a substantial
                            part of your business; or
                        </a>
                    </p>
                    <p>
                        <a name="a646931">
                            (f) your financial position deteriorates to such an
                            extent that in our opinion your capability to
                            adequately fulfil your obligations under the
                            Contract has been placed in jeopardy.
                        </a>
                    </p>
                    <p>
                        (g) your conduct or actions carried out by you or any
                        notification, judgement or other sanction against you
                        make it so that in our opinion, it is no longer
                        appropriate to continue to provide the Services to you.
                    </p>
                </div>
                <p>
                    <a name="a702244">
                        <strong>14.2 </strong>
                        <strong>Consequences of termination</strong>
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a515961">
                        Termination of the Contract will not affect our rights
                        and remedies that have accrued as at termination.
                    </a>
                </p>
                <p>
                    <a name="a744407">
                        14.3 <strong>Survival. </strong>Any provision of the
                        Contract that expressly or by implication is intended to
                        come into or continue in force on or after termination
                        will remain in full force and effect.
                    </a>
                </p>
                <p>
                    15. <a name="_Toc256000015"></a>
                    <a name="a393521">Events outside our control</a>
                </p>
                <p>
                    <a name="a257569">
                        15.1 We will not be liable or responsible for any
                        failure to perform, or delay in performance of, any of
                        our obligations under the Contract that is caused by any
                        act or event beyond our reasonable control (
                        <strong>Event Outside Our Control</strong>).
                    </a>
                </p>
                <p>
                    <a name="a198495">
                        15.2 If an Event Outside Our Control takes place that
                        affects the performance of our obligations under the
                        Contract:
                    </a>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a462368">
                            (a) we will contact you as soon as reasonably
                            possible to notify you; and
                        </a>
                    </p>
                    <p>
                        <a name="a764036">
                            (b) our obligations under the Contract will be
                            suspended and the time for performance of our
                            obligations will be extended for the duration of the
                            Event Outside Our Control. We will arrange a new
                            date for performance of the Services with you after
                            the Event Outside Our Control is over.
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a947312">
                        15.3 You may cancel the Contract affected by an Event
                        Outside Our Control which has continued for more than 30
                        days. To cancel please contact us. If you opt to cancel
                        we will refund the price you have paid, less the charges
                        reasonably and actually incurred us by in performing the
                        Services up to the date of the occurrence of the Event
                        Outside Our Control.
                    </a>
                </p>
                <p>
                    16. <a name="a440898"></a
                    ><a name="_Toc256000016">Non-solicitation</a>
                </p>
                <p>
                    <a name="a707923">
                        You must not attempt to procure services that are
                        competitive with the Services from any of our directors,
                        employees or consultants, whether as an employee or on a
                        freelance basis, during the period that we are providing
                        the Services to you and for a period of six months
                        following termination of the Contract.
                    </a>
                </p>
                <p>
                    17. <a name="_Toc256000017"></a>
                    <a name="a402607">Communications between us</a>
                </p>
                <p>
                    <a name="a282149">
                        17.1 When we refer to "in writing" in these Terms, this
                        includes email.
                    </a>
                </p>
                <p>
                    <a name="a322492">
                        17.2 Any notice or other communication given by one of
                        us to the other under or in connection with the Contract
                        must be in writing and be delivered by email.
                    </a>
                </p>
                <p>
                    <a name="a373493">
                        17.3 A notice or other communication is deemed to have
                        been received
                    </a>
                </p>
                <p>
                    <a name="a737008">
                        if sent by email, at 9.00 am the next working day after
                        transmission.
                    </a>
                </p>
                <p>
                    <a name="a1010327">
                        17.4 The provisions of this clause will not apply to the
                        service of any proceedings or other documents in any
                        legal action.
                    </a>
                </p>
                <p>
                    18. <a name="_Toc256000018"></a
                    ><a name="a273784">General</a>
                </p>
                <p>
                    <a name="a680341">
                        <strong>18.1 </strong>
                        <strong>Assignment and transfer</strong>
                    </a>
                    <strong></strong>
                </p>
                <div class="ml-4">
                    <p>
                        <a name="a785685">
                            (a) We may assign or transfer our rights and
                            obligations under the Contract to another entity
                        </a>
                        .
                    </p>
                    <p>
                        <a name="a757628">
                            (b) You may only assign or transfer your rights or
                            your obligations under the Contract to another
                            person if we agree in writing.
                        </a>
                    </p>
                </div>
                <p>
                    <a name="a738740">
                        18.2 <strong>Variation.</strong> Any variation of the
                        Contract only has effect if it is in writing and signed
                        by you and us (or our respective authorised
                        representatives).
                    </a>
                </p>
                <p>
                    <a name="a140222">
                        <strong>18.3 </strong>
                        <strong>Waiver. </strong>
                        If we do not insist that you perform any of your
                        obligations under the Contract, or if we do not enforce
                        our rights against you, or if we delay in doing so, that
                        will not mean that we have waived our rights against you
                        or that you do not have to comply with those
                        obligations. If we do waive any rights, we will only do
                        so in writing, and that will not mean that we will
                        automatically waive any right related to any later
                        default by you.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a975427">
                        <strong>18.4 </strong>
                        <strong>Severance.</strong>
                        Each paragraph of these Terms operates separately. If
                        any provision of the Contract is found to be invalid by
                        any court having competent jurisdiction, the invalidity
                        of that provision will not affect the validity of the
                        remaining provisions of the Contract, which shall remain
                        in full force and effect.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a196971">
                        <strong>18.5 </strong>
                        <strong>Third party rights.</strong>
                        The Contract is between you and us. No other person has
                        any rights to enforce any of its terms.
                    </a>
                    <strong></strong>
                </p>
                <p>
                    <a name="a608924">
                        <strong>18.6 </strong>
                        <strong>Governing law and jurisdiction.</strong>
                        The Contract is governed by English law and we each
                        irrevocably agree to submit all disputes arising out of
                        or in connection with the Contract to the exclusive
                        jurisdiction of the English courts.
                    </a>
                    <strong></strong>
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    methods: {
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
    },
}
</script>

<style scoped>
p {
    color: black;
}
body a:not([href]):not([tabindex]) {
    color: #000000 !important;
    cursor: pointer;
}
</style>
